<template>
    <div class="contentblock contentblock--gray contentblock--no-margin-and-padding">
        <section class="contentblock__content">
            <ul class="shop__progressbar">
                <li v-for="(step, index) in Steps" 
                    @click="clickStep(index + 1)"
                    :class="{ active: index <= currentStepIndex, current: index == currentStepIndex, clickable: hasClickListener(index + 1) }" 
                    :key="index"><span class="shop__progressbar_steptext">{{step}}</span></li>
            </ul>
        </section>
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        props: {
            currentStepIndex: {
                type: Number,
                required: true
            },
            processType: {
                type: String,
                required: true
            }
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            Steps() {
                if (this.processType == "BnT") {
                    return new Array(this.Strings['Shop.Progressbar_BnT_Configure'], this.Strings['Shop.Progressbar_BnT_Addresses'], this.Strings['Shop.Progressbar_BnT_Review'], this.Strings['Shop.Progressbar_BnT_Confirmation']);
                } else if (this.processType == "SnA") {
                    return new Array(this.Strings['Shop.Progressbar_SnA_Addresses'], this.Strings['Shop.Progressbar_SnA_Equipment'], this.Strings['Shop.Progressbar_SnA_Review'], this.Strings['Shop.Progressbar_SnA_Confirmation']);
                }

                return new Array();
            }            
        },
        methods: {
            hasClickListener(step) {
                var eventName = 'clickstep' + step;
                return this.$listeners && this.$listeners[eventName]
            },
            clickStep(step) {
                var eventName = 'clickstep' + step;
                this.$emit(eventName);
            }
        }
    };
</script>